
import React, {useState, useEffect, useRef} from 'react';
import Modal from "antd/es/modal/Modal";
import {useSelector, useDispatch, createSelectorHook} from "react-redux";
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {
  Button,
  Cascader,
  Checkbox,
  ColorPicker,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Slider,
  Switch,
  TreeSelect,
  Upload, Card, Space, Divider, message
} from 'antd';
import {useForm} from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import {CusBaseAdd, CusBaseDetail, CusBaseList, CusBaseUpdate} from "../../../../api/CusManage";
import moment from "moment";
import {GetEnumList} from "../../../../api/SystemApi";


const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const ModalPlus = ({form, record, open, disabled, callback}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [myFormOther] = useState(form);
  const [myFormAdd] = Form.useForm();
  const [componentDisabled, setComponentDisabled] = useState(!disabled);

  /**
   * 是否渠道
   */
  const [isChannel, setIsChannel] = useState('否')
  /**
   * 渠道列表
   */
  const [channelMerchants, setChannelMerchants] = useState([])

  //客户基本信息
  const [cusBaseAndContact, setBaseAndContact] = useState({});

  const callbackHandler = () => {

  }


  //客户联系信息
  const handleCancel = () => {
    callback(false)

  };

  const onFinishToUpdate = (values) => {
    CusBaseUpdate(values).then(res => {
        if (res.data.status === 200) {
          messageApi.success('编辑成功，即将返回', 5)
          callback(false)
        }
      }
    ).catch();
  }
  const onFinishToAdd = (values) => {
    console.log(values)
    CusBaseAdd(values).then(res => {
      if (res.data.status === 200) {
        CusBaseList({}).then(res => {
            if (res.data.status === 200) {
              messageApi.success('添加成功，即将返回', 5)
              callback(false)
            }
          }
        ).catch(
          error => {
          }
        )
      }
    }).catch();
  }


  useEffect(() => {
    //  获取所有渠道商
    //获取枚举值
    GetEnumList({
      dsColumn: 'channelMerchants'
    }).then(res => {
      const data = res.data.data;
      const status = res.data.status;
      if (status === 200) {
        data.map((item,index) => {
          item.key = index
          item.value = item.enumName
          item.label = item.enumName
        })
        setChannelMerchants(data)
      } else {
        messageApi.error('系统错误', 5)
      }
    }).catch(error => {

    }).finally(() => {
      }
    )


  }, [])

  return (
    <>
      {contextHolder}
      <Modal open={open}
        // onOk={handleOk}
             onCancel={handleCancel}
             okText='提交'
             cancelText='取消'
             width='60rem'
             title='客户基本信息'
             footer={null}
      >
        {!disabled
        && <Checkbox
          disabled={disabled}
          checked={componentDisabled}
          onChange={(e) => setComponentDisabled(e.target.checked)}
        >
          开启编辑模式
        </Checkbox>}
        <Form
          style={{paddingTop: '2rem'}}
          // labelCol={{span: 6}}
          // wrapperCol={{span: 18}}
          layout="horizontal"
          disabled={disabled ? disabled : !componentDisabled}
          form={record === undefined ? myFormAdd : myFormOther}
          onFinish={record === undefined ? onFinishToAdd : onFinishToUpdate}
          // initialValues={}
          // autoComplete={true}
        >
          <Space style={{display: 'flex', marginBottom: 8}} align="baseline" direction={"vertical"}>
            <Space direction={"horizontal"}>
              <Form.Item label="是否为渠道商" name={'isChannelMerchants'} initialValue={'否'}>
                <Radio.Group onChange={e => {
                  setIsChannel(e.target.value)
                }}
                             defaultValue={'否'}
                >
                  <Radio checked key={'是'} value={'是'}>是</Radio>
                  <Radio key={'否'} value={'否'}>否</Radio>
                </Radio.Group>
              </Form.Item>
              {
                isChannel==='是' &&
                <Form.Item label="渠道商名称" name={'enterpriseName'} required={[{require: true, message: '请选择渠道商'}]}>
                  <Input onChange={(v)=>{
                    myFormAdd.setFieldValue('taxId',v.target.value)
                  }} />
                </Form.Item>
              }
              {
                isChannel ==='否' &&
                <>
                  <Form.Item label="客户名称" name={'enterpriseName'} required={[{require: true, message: '请输入客户名称'}]}>
                    <Input onChange={(v)=>{
                      myFormAdd.setFieldValue('taxId',v.target.value)
                    }}/>
                  </Form.Item>
                  <Form.Item label="关联渠道商" name={'channelMerchants'} >
                    <Select
                      style={{width: '15rem'}}
                      allowClear
                      showSearch={true} autoClearSearchValue={true}
                      options={channelMerchants}/>
                  </Form.Item>
                </>

              }

            </Space>

            <Space direction={"horizontal"}>
              <Form.Item label="总经理" name={'generalManager'}>
                <Input/>
              </Form.Item>

              <Form.Item label="法人" name={'legalPerson'}>
                <Input/>
              </Form.Item>
            </Space>

          </Space>
          <Space style={{display: 'flex', marginBottom: 8}} align="baseline">
            {/*<Form.Item initialValue={'SXSF' + moment().format('YYYYMMDDHHmmss')} label="客户编号" name={'cusNumber'}*/}
            {/*           required={[{require: true, message: '请输入客户编号'}]}>*/}
            {/*  <Input disabled defaultValue={'SXSF' + moment().format('YYYYMMDDHHmmss')}/>*/}
            {/*</Form.Item>*/}
            <Form.Item initialValue={userInfo.name} label="客户经理" name={'cusManage'} required={[{require: true, message: '请输入客户经理'}]}>
              <Input disabled defaultValue={userInfo.name}/>
            </Form.Item>
          </Space>


          <Divider/>
          <p style={{
            fontWeight: 'bold'
          }}>
            开票信息
          </p>
          <Form.Item label={<span>
            {isChannel==='是'?'渠道商':'直签客户'}
            税号
          </span>} name={'taxId'}
                     rules={[{required: true, message: '请输入税号'}]}
          >
            <Input  placeholder={'非渠道商，则填写填写客户税号(不想查可随意填写)'}/>
          </Form.Item>

          <Divider/>
          <p style={{
            fontWeight: 'bold'
          }}>
            邮寄信息
          </p>
          <Form.Item label="邮寄地址" name={'mailAddress'}
            // required={[{require:true,message:'请输入邮寄地址'}]}
          >
            <Input/>
          </Form.Item>


          <Divider/>
          <p style={{
            fontWeight: 'bold'
          }}>
            客户联系信息
          </p>

          <Form.List name="cusInfoVos">
            {(fields, {add, remove}) => (
              <>
                {fields.map(({key, index, name, ...restField}) => (

                  <Space
                    key={key}
                    style={{
                      display: 'flex',
                      marginBottom: 1,
                    }}
                    wrap={true}
                    align="baseline"
                    size='small'
                  >

                    <Form.Item
                      label='联系人'
                      {...restField}
                      name={[name, 'contactName']}
                      rules={[
                        {
                          required: false,
                          message: 'Missing first name',
                        },
                      ]}
                    >
                      <Input placeholder="联系人"/>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      label='部门'
                      name={[name, 'deptName']}
                      rules={[
                        {
                          required: false,
                          message: 'Missing last name',
                        },
                      ]}
                    >
                      <Input placeholder="部门"/>
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      label='职位'
                      name={[name, 'position']}
                      rules={[
                        {
                          required: false,
                          message: 'Missing last name',
                        },
                      ]}
                    >
                      <Input placeholder="职位"/>
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      label='负责事项'
                      name={[name, 'responsibleMatters']}
                      rules={[
                        {
                          required: false,
                          message: 'Missing last name',
                        },
                      ]}
                    >
                      <TextArea placeholder="负责事项" maxLength={300} showCount={true} rows={1}/>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      label='电话'
                      name={[name, 'telPhone']}
                      rules={[
                        {
                          required: false,
                          message: 'Missing last name',
                        },
                      ]}
                    >
                      <Input placeholder="电话"/>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      label='微信'
                      name={[name, 'wechat']}
                      rules={[
                        {
                          required: false,
                          message: 'Missing last name',
                        },
                      ]}
                    >
                      <Input placeholder="微信"/>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      label='邮箱'
                      name={[name, 'email']}
                      rules={[
                        {
                          required: false,
                          message: 'Missing last name',
                        },
                      ]}
                    >
                      <Input placeholder="邮箱"/>
                    </Form.Item>
                    {!disabled &&
                    <MinusCircleOutlined onClick={() => remove(name)}/>
                    }
                  </Space>
                ))}
                {!disabled &&
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                    添加信息
                  </Button>
                </Form.Item>
                }


              </>
            )}
          </Form.List>
          {!disabled &&
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{left: '52rem', top: '3rem'}}>
              提交
            </Button>
          </Form.Item>
          }
        </Form>

        <Button type="primary" style={{left: '46rem', top: '-0.5rem'}} onClick={handleCancel}>
          关闭
        </Button>

      </Modal>
    </>

  );
};

export default ModalPlus;
